import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
//
import { HOST_API } from "../config-global";

// ----------------------------------------------------------------------

const apiSlice = createApi({
    reducerPath: "apiRTK",
    baseQuery: fetchBaseQuery({
        baseUrl: HOST_API,
        prepareHeaders: async (headers) => {
            const token = localStorage.getItem("accessToken");

            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    // tagTypes: ['Shipment', 'ShipmentDetail', 'Order', 'OrderDetail', 'PaymentMethod', 'Warehouse', 'Address', 'Store', 'StoreOption', 'Carrier', 'Pickup', 'Package', 'PredefinedPackage', 'Automation', 'Transaction', 'Notification'],
    endpoints: () => ( {} ) // “endpoints” 代表对该服务器的操作和请求
});

export default apiSlice;